import FormatUtil from '../util/FormatUtil';

export interface IResultCDRItem{
    cdrID:string;
    sipCallID:string;
    dateReceived:Date;
    dateAnsweredAtPSAP:string;
    dateTerminated:string;
    callbackNumber:string;
    subscriberPreferenceValue:string;
    providerContactNumber:string;
    a1:string;
    a3:string;
    pc:string;
    country:string;
    message:string;
    nam:string;
    loc:string;
    nocUrgentNumber:string;
    hno:string;
    rd:string;
}

export interface ICDRData {
    display: string;
    time: string;
    cbn:string;
    address:string;
    city:string;
    state:string;
    zipcode:string;
    country:string;
    message:string;
    name:string;
    location:string;
    providerContactNumber:string;
}

export function validateResultCDRItem($item:IResultCDRItem){
    
    //let isOk:boolean=false;//temporarily disabling the filter
    let isOk:boolean=true;//temporarily disabling the filter
    /*
    if($item.a1 && $item.a1.trim()) isOk=true;
    if($item.a3 && $item.a3.trim()) isOk=true
    if($item.pc && $item.pc.trim()) isOk=true;
    if($item.country && $item.country.trim()) isOk=true;
    if($item.nam && $item.nam.trim()) isOk=true;
    if($item.loc && $item.loc.trim()) isOk=true;
    if($item.rd && $item.rd.trim()) isOk=true;
    if($item.hno && $item.hno.trim()) isOk=true;
    */
    return isOk;
}

export function convertResultCDRItem_To_ICDRDataItem($input:IResultCDRItem){

    let isToday:boolean=false;
    let dateReceived:Date = new Date($input.dateReceived);

    isToday = FormatUtil.isToday(dateReceived);

    let display:string = $input.callbackNumber;
    let time:string = isToday?FormatUtil.dateHMS(new Date($input.dateReceived),false,true):FormatUtil.dateMDHM(dateReceived,false,true);

    let cbn:string = $input.callbackNumber;
    let city:string = $input.a3 || "";
    let state:string = $input.a1 || "";
    let zipcode:string = $input.pc || "";
    let country:string = $input.country || "";
    let message:string = $input.message || "";
    let name:string = $input.nam || "";
    let location:string = $input.loc || "";
    let providerContactNumber:string = $input.providerContactNumber || "";

    //backup for providerContactNumber is that we use the noc if available?
    if(providerContactNumber===""){
        if($input.nocUrgentNumber){
            providerContactNumber = $input.nocUrgentNumber;
        }
    }

    let road:string = $input.rd || "";
    let houseNumber:string = $input.hno || "";
    let address:string = String(houseNumber+" "+road).trim();

    let newData:ICDRData = {
        display,
        time,
        cbn,
        address,
        city,
        state,
        zipcode,
        country,
        message,
        name,
        location,
        providerContactNumber,
    }

    return newData;
}

export function handleSetICDRData($data:IResultCDRItem[]):ICDRData[]{
    //return $data.filter(validateResultCDRItem).map(convertResultCDRItem_To_ICDRDataItem);
    return $data.map(convertResultCDRItem_To_ICDRDataItem);
}
